module.exports = __webpack_public_path__ + "img/payment-left.b57733e2.png";